import React, { useCallback, useState } from "react";
import "./UserInfo.scss";
import { useUser } from "../../../hooks/useUser";
import { Button } from "../../general/Button/Button";
import { UpdateProfileModal } from "./UpdateProfile/UpdateProfileModal";
import { EditableProfileFields } from "./UpdateProfile/types";
import styles from "./UserInfo.module.scss";
import { UpdateNameModal } from "./UpdateProfile/UpdateNameModal";

export const UserInfo: React.FC = () => {
    const [showNameUpdate, setShowNameUpdate] = useState(false);
    const [update, setUpdate] = useState<EditableProfileFields | null>(null);
    const user = useUser();

    const handleCancelUpdate = useCallback(() => {
        setUpdate(null);
    }, []);

    return (
        <div className="settings__user-info">
            <div className={styles.container}>
                <div className={styles.row}>
                    <div className={styles.data}>
                        <span className={styles.label}>Full Name</span>
                        <span className={styles.value}>
                            {user.preferredName}
                        </span>
                    </div>
                    <Button
                        variant="secondary"
                        onClick={() => setShowNameUpdate(true)}
                    >
                        Edit name
                    </Button>
                </div>
                <div className={styles.row}>
                    <div className={styles.data}>
                        <span className={styles.label}>Email address</span>
                        <span className={styles.value}>{user.email}</span>
                    </div>
                    <Button
                        variant="secondary"
                        onClick={() => setUpdate("email")}
                    >
                        Edit email
                    </Button>
                </div>
                <div className={styles.row}>
                    <div className={styles.data}>
                        <span className={styles.label}>Phone number</span>
                        <span className={styles.value}>{user.phoneNumber}</span>
                    </div>
                    <Button
                        variant="secondary"
                        onClick={() => setUpdate("phoneNumber")}
                    >
                        Edit phone number
                    </Button>
                </div>
            </div>

            <UpdateNameModal
                show={showNameUpdate}
                onClose={() => setShowNameUpdate(false)}
            />
            <UpdateProfileModal update={update} onClose={handleCancelUpdate} />
        </div>
    );
};
